import { defineComponent as t, openBlock as c, createBlock as o, unref as r, mergeProps as s, withCtx as d, createElementVNode as l } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceShieldOutlined",
  __name: "IconReassuranceShieldOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (p, e) => (c(), o(r(i), s(n, { "view-box": "0 0 48 48" }), {
      default: d(() => [...e[0] || (e[0] = [
        l("path", { d: "M27.227 23.1c.395.148.984-.405 1.287-1.235.313-.829.225-1.61-.17-1.768-.393-.158-.972.398-1.285 1.226s-.228 1.629.168 1.777m3.432-.425c-.191.86-.008 1.657.41 1.73.454.1.918-.524 1.11-1.394s.018-1.655-.41-1.74c-.426-.085-.92.544-1.11 1.404m-7.555-.701a.33.33 0 0 0-.244.003l.029.005a.34.34 0 0 0-.183.311 6.9 6.9 0 0 0 .912 2.566 7.5 7.5 0 0 0 .784 1.12 8.1 8.1 0 0 0 3.327 2.285 8.2 8.2 0 0 0 2.628.463.32.32 0 1 0 .063-.637 9.23 9.23 0 0 1-4.386-2.01 9 9 0 0 1-1.582-1.771 13.4 13.4 0 0 1-1.169-2.17.33.33 0 0 0-.179-.165" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M26.681 9.064a.5.5 0 0 0-.437-.079 228 228 0 0 0-1.352.4c-2.249.668-4.045 1.203-5.8 1.29-2.043.102-4.043-.406-6.584-2.155a.5.5 0 0 0-.776.325l.492.087-.492-.087-2.557 14.498c-1.04 5.902 1.857 10.529 4.937 13.638a27.7 27.7 0 0 0 6.274 4.701l.115.06.03.016.01.004.002.002.224-.447-.223.447a.5.5 0 0 0 .28.05l-.057-.497.057.496h.004l.01-.001.034-.004L21 41.79a18 18 0 0 0 .48-.075 27.7 27.7 0 0 0 7.025-2.198c3.957-1.867 8.261-5.225 9.302-11.127l2.556-14.497-.492-.087.492.087a.5.5 0 0 0-.615-.572c-3.028.768-5.101.558-6.986-.236-1.635-.69-3.14-1.819-5.022-3.231l-1.06-.79M12.584 9.769c2.408 1.519 4.448 2.01 6.557 1.905 1.887-.094 3.82-.67 6.067-1.34l1.077-.319.834.625c1.877 1.41 3.497 2.626 5.255 3.367 1.949.822 4.053 1.06 6.873.46l-2.425 13.75c-.96 5.447-4.93 8.596-8.745 10.397a26.7 26.7 0 0 1-7.215 2.186h-.007a16 16 0 0 1-.4-.22 26.7 26.7 0 0 1-5.632-4.302c-2.97-2.997-5.623-7.314-4.663-12.76L12.584 9.77",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
